<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">จัดการข้อมูลผู้ใช้งาน</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> จัดการข้อมูลผู้ใช้งาน
      </v-card-title>
      <v-row no-gutters class="mx-2">
        <v-col cols="12" class="py-0 pr-2">
          <a-tabs @change="getRequest">
            <a-tab-pane :key="0"><span slot="tab">ทั้งหมด <a-tag color="#27AB9C" style="border-radius: 8px;">{{ countAll }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="1"><span slot="tab">กำลังใช้งาน <a-tag color="#1AB759" style="border-radius: 8px;">{{ countActive }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="2"><span slot="tab">ยกเลิก <a-tag color="#F5222D" style="border-radius: 8px;">{{ countInactive }}</a-tag></span></a-tab-pane>
          </a-tabs>
        </v-col>
        <v-col cols="12" md="6" sm="12" class="" :class="!MobileSize ? 'pl-0 pr-3 mb-3 pt-3' : 'pl-0 pr-2 mb-3 pt-3'">
          <v-text-field v-model="search" placeholder="ค้นหาชื่อผู้ใช้งาน" outlined dense hide-details>
            <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="12" sm="12" class="pt-3 pb-3">
          <v-row dense>
            <v-col cols="12" md="6" sm="8" class="pt-2">
              <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-if="StateStatus === 0">รายการผู้ใช้ในร้านค้าทั้งหมด {{ showCountRequest }} รายการ</span>
              <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 1">รายการผู้ใช้ในร้านค้าที่กำลังใช้งาน {{ showCountRequest }} รายการ</span>
              <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 2">รายการผู้ใช้ในร้านค้าที่ยกเลิก {{ showCountRequest }} รายการ</span>
            </v-col>
            <v-col cols="12" md="6" sm="4" class="pt-0" align="right" v-if="position === 'super_admin'">
              <v-btn @click="dialogAddEdit = true" dense color="#27AB9C" :width="MobileSize ? '100%' : ''" :class="MobileSize || IpadSize ? 'white--text' : 'ml-4 pl-8 pr-8 white--text'">
                <v-icon>mdi-plus-circle-outline</v-icon>
                เพิ่มข้อมูล
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="disableTable === false" class="mt-2">
          <v-data-table
          :headers="headers"
          :items="userList"
          :search="search"
          :page.sync="page"
          @pagination="countRequest"
          no-results-text="ไม่พบข้อมูลผู้ใช้"
          no-data-text="ไม่พบข้อมูลผู้ใช้"
          :footer-props="{'items-per-page-text':'จำนวนแถว'}"
          @update:items-per-page="itemsPerPage"
          :items-per-page="10"
          class="elevation-1"
          >
            <template v-slot:[`item.no`]="{ item }">
              <span>{{userList.indexOf(item) + 1}}</span>
            </template>
            <template v-slot:[`item.position`]="{ item }">
              <span v-if="item.position === 'super_admin'">ซุปเปอร์แอดมิน</span>
              <span v-if="item.position === 'admin'">แอดมิน</span>
              <span v-if="item.position === 'sales'">ฝ่ายขาย</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'active'">
                  <v-chip small color="#F0F9EE" text-color="#1AB759">กำลังใช้งาน</v-chip>
                </span>
                <span v-else>
                  <v-chip small color="#F9EEEE" text-color="#F5222D">ปิดการใช้งาน</v-chip>
                </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-row>
                <v-col>
                  <v-btn text rounded color="#27AB9C" :class="!MobileSize? 'px-2' : 'pa-0 ma-0'" small  @click="detailUser(item.emp_id)">
                    <v-icon small>mdi-file-document-outline</v-icon>
                    <span>รายละเอียด</span>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.switch`]="{ item }">
              <v-switch color="#52C41A" v-model="item.status" @click="switchStatus(item.emp_id)"></v-switch>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" v-if="disableTable === true" align="center">
          <div class="my-5">
            <v-img src="@/assets/emptypo.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
          </div>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;">ไม่มีรายการผู้ใช้</h2>
          <h2 style="padding-bottom: 50px; color: #27AB9C;">กรุณากดที่ปุ่ม <b>“เพิ่มผู้ใช้”</b> เพื่อรายการที่สมบูรณ์</h2>
        </v-col>
      </v-row>

      <!-- dialog Detail Add Edit User -->
      <v-dialog max-width="569px" v-model="dialogAddEdit" persistent>
        <v-card :min-height="status !== 'edit' ? '500px' : '470px'" align="center" class="rounded-lg">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-weight: 700; font-size: 20px; line-height: 30px; color: #27AB9C;">การกำหนดสิทธิ์การใช้งาน</span>
            <v-btn icon dark @click="resetDataAddEdit('dialogAddEdit')">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br/>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="2" sm="12" align="start">
                <v-img src="@/assets/ICON/GraczBusinessman.png" width="60px" height="60px"></v-img>
              </v-col>
              <v-col cols="12" md="9" sm="12" align="start" class="mt-4 ml-0 pl-0">
                <span style="font-weight: 600; font-size: 18px; line-height: 26px; color: #333333;">รายละเอียดตำแหน่งและสิทธิ์การใช้งาน</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <!-- card list approver -->
            <v-row justify="center" v-if="clickSelectUser === false">
              <v-col cols="12" md="12" align="start"  v-if="status !== 'edit'"> ค้นหาผู้ใช้งาน</v-col>
              <v-col cols="12" md="12" align="start"  v-if="status !== 'edit'" class="mt-0 pt-0">
                <v-text-field v-model="searchUser" @change="getUserForSelect()" placeholder="ระบุ Username" outlined dense hide-details>
                  <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
                </v-text-field>
              </v-col>
              <!-- detail user add-->
              <v-col cols="12" align="start" style="max-height: 250px;">
                <div v-if="listUserForSelect.length !== 0">
                  <v-card height="100%" outlined class="mb-2">
                    <v-card-text :class="MobileSize ? 'px-0' : 'mb-4 pb-0'">
                      <div class="d-flex flex-no-wrap">
                        <v-avatar :class="!MobileSize ? 'ma-2' : ''" :size="!MobileSize? '132' : '60'" tile>
                          <v-img :src="listUserForSelect[0].emp_image" contain style="border-radius: 8px;" v-if="listUserForSelect[0].emp_image !== null"></v-img>
                          <v-img src="@/assets/icons/businessman.jpg" contain style="border-radius: 8px; border: 1px #E0E0E0 solid;" v-else></v-img>
                        </v-avatar>
                        <div class="mt-2">
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">ชื่อ-สกุล : <b>{{ listUserForSelect[0].emp_name }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">อีเมล : <b>{{ listUserForSelect[0].emp_email }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">เบอร์โทรศัพท์ : <b>{{ listUserForSelect[0].emp_phone }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''" v-if="status === 'edit'">ตำแหน่ง : <b>{{ selectedUserDetail.emp_phone }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''" v-if="status === 'edit'">รหัสพนักงาน : <b>{{ selectedUserDetail.emp_phone }}</b></p>
                        </div>
                        {{listUserForSelect[0].status}}
                        <v-row justify="end" dense class="mb-2 d-flex align-end flex-column" v-if="status === 'edit'">
                          <v-btn icon><v-icon size="20" color="#27AB9C">mdi-pencil</v-icon></v-btn>
                        </v-row>
                        <!-- <v-row justify="end" dense class="mb-2 d-flex align-end flex-column" v-else>
                          <v-btn @click="SelectUserToAdd()" dense  color="#27AB9C" class="mt-0 pt-0 ml-4 pl-8 pr-8 white--text">เลือก</v-btn>
                        </v-row> -->
                      </div>
                      <v-row justify="end" dense class="mb-2 mr-2" v-if="status !== 'edit'">
                        <v-btn @click="SelectUserToAdd()" dense  color="#27AB9C" class="mt-0 pt-0 ml-4 pl-8 pr-8 white--text">เลือก</v-btn>
                      </v-row>
                      <v-divider v-if="status === 'edit'"></v-divider>
                      <v-col cols="12" md="12" align="end" class="mb-0 pb-0" v-if="status === 'edit'">
                        <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">สร้างเมื่อ : 31 พฤษภาคม 2565</p>
                        <p :class="MobileSize ? 'fontSizeCardTitleMobile' : 'mb-0 pb-0'">แก้ไขเมื่อ : 31 พฤษภาคม 2565</p>
                      </v-col>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>

              <!-- detail user edit-->
              <v-col cols="12" align="start" v-if="status === 'edit'">
                <div>
                  <v-card height="100%" outlined class="mb-2">
                    <v-card-text :class="MobileSize ? 'px-0' : 'mb-4 pb-0'">
                      <!-- btn เปิดการใช้งาน -->
                      <v-col cols="12" md="12" align="end" class="ma-0 pa-0" v-if="selectedUserDetail.status === 'inactive' && position === 'super_admin'">
                        <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="switchStatus('active')">เปิดการใช้งาน</v-btn>
                      </v-col>
                      <!-- detail user -->
                      <div class="d-flex flex-no-wrap">
                        <v-avatar :class="!MobileSize ? 'ma-2' : ''" :size="!MobileSize? '132' : '60'" tile>
                          <v-img :src="selectedUserDetail.emp_image" contain style="border-radius: 8px;" v-if="selectedUserDetail.emp_image !== null"></v-img>
                          <v-img src="@/assets/icons/businessman.jpg" contain style="border-radius: 8px; border: 1px #E0E0E0 solid;" v-else></v-img>
                        </v-avatar>
                        <div class="mt-2">
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">ชื่อ-สกุล : <b>{{ selectedUserDetail.emp_name }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">อีเมล : <b>{{ selectedUserDetail.emp_email }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">เบอร์โทรศัพท์ : <b>{{ selectedUserDetail.emp_phone }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">ตำแหน่ง :
                            <b v-if="selectedUserDetail.position === 'super_admin'">ซุปเปอร์แอดมิน</b>
                            <b v-if="selectedUserDetail.position === 'admin'">แอดมิน</b>
                            <b v-if="selectedUserDetail.position === 'sales'">ฝ่ายขาย</b>
                          </p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">รหัสพนักงาน : <b>{{ selectedUserDetail.emp_code }}</b></p>
                        </div>
                        <v-row justify="end" dense class="mb-2" v-if="selectedUserDetail.status === 'active' && position === 'super_admin'">
                          <v-btn @click="edit()" icon><v-icon size="20" color="#27AB9C">mdi-pencil</v-icon></v-btn>
                        </v-row>
                      </div>
                      <!-- more detail for edit -->
                      <v-divider v-if="status === 'edit'"></v-divider>
                      <v-col cols="12" md="12" align="end" class="mb-0 pb-0" v-if="status === 'edit'">
                        <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">สร้างเมื่อ :
                          {{ selectedUserDetail.created_at !== '' ? formatDateTH(selectedUserDetail.created_at) : '-' }}
                        </p>
                        <p :class="MobileSize ? 'fontSizeCardTitleMobile' : 'mb-0 pb-0'">แก้ไขเมื่อ :
                          {{ selectedUserDetail.updated_at !== '' ? formatDateTH(selectedUserDetail.updated_at) : '-' }}
                        </p>
                      </v-col>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
              <!-- if search user not found -->
              <v-col cols="12" class="px-12 align-self-end" align="center" v-if="showUser === false && status !== 'edit'">
                <div style="padding-top: 30px;">
                  <v-img src="@/assets/icons/notfoundAdminUser.png" max-height="146px" max-width="135px" height="100%" width="100%" contain></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #333333;">
                  <span :class="MobileSize ? 'fontSizeCardTitleMobile' : 'fontSizeCardTitle'">{{showStatus}}</span><br/><br/>
                  <p v-if="showStatus === 'ไม่พบข้อมูล'" style="font-weight: 500; font-size: 16px; text-transform: #333333;">
                    กรุณาเพิ่มข้อมูลใน <a href=""><U color="#1B5DD6">
                        <font color="#1B5DD6">One ID</font>
                      </U></a> หรือ <font color="#27AB9C">
                      แชทกับพาณิชย์
                    </font>
                  </p>
                </h2>
              </v-col>
            </v-row>

            <!-- card selected approver -->
            <v-row v-else>
              <v-col cols="12" align="start">
                <v-form ref="form" :lazy-validation="lazy">
                  <v-card outlined elevation="0">
                    <v-card-text :class="MobileSize ? 'px-0' : ''">
                      <div class="d-flex">
                        <v-avatar class="ma-4" :size="!MobileSize? '132' : '60'" tile>
                          <v-img :src="selectedUserDetail.emp_image" contain style="border-radius: 8px;" v-if="selectedUserDetail.emp_image !== null "></v-img>
                          <v-img src="@/assets/icons/businessman.jpg" contain style="border-radius: 8px; border: 1px #E0E0E0 solid;" v-else></v-img>
                        </v-avatar>
                        <div>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : 'ma-0'">ชื่อ :
                            <v-text-field v-model="selectFirstName" class="ml-3 d-inline-block" hide-details outlined dense></v-text-field>
                            <!-- <b>{{ selectedUserDetail.first_name }}</b> -->
                          </p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : 'mt-2'">สกุล :
                            <v-text-field v-model="selectLastName" class="ml-1 d-inline-block" hide-details outlined dense></v-text-field>
                            <!-- <b>{{ selectedUserDetail.last_name }}</b> -->
                          </p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">อีเมล : <b>{{ selectedUserDetail.emp_email }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : ''">เบอร์โทรศัพท์ : <b>{{ selectedUserDetail.emp_phone }}</b></p>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : 'mb-0'">กรุณาเลือกตำแหน่ง :</p>
                          <v-autocomplete
                            v-model="selectPosition"
                            :items="positionList"
                            item-text="text"
                            item-value="id"
                            outlined dense
                            auto-select-first
                            :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                          ></v-autocomplete>
                          <p :class="MobileSize ? 'fontSizeCardTitleMobile' : 'mb-0'">รหัสพนักงาน :</p>
                          <v-text-field
                          v-model="empNo"
                          maxLength="8"
                          :rules="[
                            v => !!v || 'กรุณากรอกพนักงาน',
                            v => v.length >= 5 || 'กรุณากรอกมากกว่า 5 ตัวอักษร']"
                          outlined dense></v-text-field>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                  <v-row justify="end" dense class="mt-4 mb-4 mr-0">
                    <v-btn dense dark outlined color="#F5222D" class="pl-7 pr-7 mt-2" @click="switchStatus('inactive')" v-if="status === 'edit'">ยกเลิกการใช้งาน</v-btn>
                    <v-btn dense dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="resetDataAddEdit('dialogAddEdit')" v-if="status !== 'edit'">ยกเลิก</v-btn>
                    <v-btn dense color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="save()" :disabled="selectPosition === '' || empNo === ''? true : false">บันทึก</v-btn>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- dialog comfirm Add -->
      <v-dialog max-width="464px"  v-model="dialogConfirmInactive" persistent>
        <v-card max-height="300px" align="center" class="rounded-lg" style="overflow-y: hidden;">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px" v-if="status === 'inactive'"><font color="#27AB9C">ยกเลิกการใช้งาน</font></span>
            <span class="flex text-center ml-5" style="font-size:20px" v-if="status === 'active'"><font color="#27AB9C">เปิดการใช้งาน</font></span>
            <v-btn icon dark @click="resetDataAddEdit('dialogConfirmInactive')">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br/>
          <v-card-text class="mb-4">
            <v-icon size="70px" color="#E9A016" class="mb-0 ml-2">mdi-alert-circle-outline</v-icon><br><br>
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;" v-if="status === 'inactive'">คุณยกเลิกการใช้งาน <b>{{selectedUserDetail.emp_name}}</b></span>
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;" v-if="status === 'active'">คุณเปิดการใช้งาน <b>{{selectedUserDetail.emp_name}}</b></span>
            <br/>
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">คุณต้องการทำรายการนี้ ใช่หรือไม่ ?</span>
          </v-card-text>
          <v-card-actions >
          <v-row justify="center" dense class="mb-4">
            <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="resetDataAddEdit('dialogConfirmInactive')">ยกเลิก</v-btn>
            <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="switchStatusUser()">ตกลง</v-btn>
          </v-row>
        </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog Inactive Add Edit Success -->
      <v-dialog v-model="dialogSuccess" persistent width="373">
        <v-card style="background: #FFFFFF; border-radius: 4px;" min-height="246px">
          <v-toolbar align="center" color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px">
              <font color="#27AB9C" v-if="status === 'inactive'">ยกเลิกการใช้งาน</font>
              <font color="#27AB9C" v-else>การกำหนดสิทธิ์การใช้งาน</font>
            </span>
            <v-btn icon dark @click="resetDataAddEdit('dialogSuccess')">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card-text>
              <v-row justify="center" no-gutters dense>
                <v-col cols="12" align="center">
                  <v-img src="@/assets/ImageINET-Marketplace/ICONShop/successIcon.png" contain max-height="70" max-width="70"></v-img>
                </v-col>
                <v-col cols="12" align="center" class="mt-6">
                  <p style="font-weight: 500; font-size: 14px; line-height: 22px; color: color: #333333;" class="pt-0 mt-0">เสร็จสิ้น</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
import moment from 'moment'
export default {
  data () {
    return {
      seller_shop_id: '',
      position: '',
      // tab
      StateStatus: 0,
      showCountRequest: 0,
      countAll: 0,
      countActive: 0,
      countInactive: 0,

      // table
      disableTable: false,
      search: '',
      page: 1,
      itemsPerPage: 5,
      headers: [
        { text: 'ลำดับ', value: 'no', filterable: false, sortable: false, align: 'start', width: '50px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อ - นามสกุล', value: 'emp_name', filterable: true, sortable: false, align: 'start', width: '150px', class: 'backgroundTable fontTable--text' },
        { text: 'ตำแหน่ง', value: 'position', filterable: false, sortable: false, align: 'start', width: '120px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสฝ่ายขาย', value: 'emp_code', filterable: false, sortable: false, align: 'start', width: '90px', class: 'backgroundTable fontTable--text' },
        { text: 'จำนวนลูกค้าที่รับผิดชอบ', value: 'total_customer', filterable: false, sortable: false, align: 'start', width: '90px', class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, align: 'start', width: '50px', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'action', filterable: false, align: 'start', sortable: false, width: '120px', class: 'backgroundTable fontTable--text' }
      ],
      userAll: {
        all: [],
        active: [],
        inactive: []
      },
      userList: [],

      // add edit cat
      showUser: true,
      showStatus: '',
      status: '',
      clickSelectUser: false,
      dialogAddEdit: false,
      listUserForSelect: [],
      searchUser: '',
      selectedUserDetail: [],
      positionList: [
        { text: 'ซุปเปอร์แอดมิน', id: 'super_admin' },
        { text: 'แอดมิน', id: 'admin' },
        { text: 'ฝ่ายขาย', id: 'sales' }
      ],
      lazy: false,
      selectFirstName: '',
      selectLastName: '',
      selectPosition: '',
      empNo: '',
      dialogConfirmInactive: false,
      dialogSuccess: false
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/ManageUserMobile').catch(() => {})
      } else {
        this.$router.push('/Order/ManageUser').catch(() => {})
      }
    },
    StateStatus (val) {
      // console.log('state is', val)
      if (val === 0) {
        this.userList = this.userAll.all !== undefined ? this.userAll.all : []
        if (this.userList.length === 0) {
          this.disableTable = true
          this.showCountRequest = 0
        } else {
          this.disableTable = false
        }
      } else if (val === 1) {
        this.userList = this.userAll.active !== undefined ? this.userAll.active : []
        // console.log('data', this.userList)
        if (this.userList.length === 0) {
          this.disableTable = true
          this.showCountRequest = 0
        } else {
          this.disableTable = false
        }
      } else if (val === 2) {
        this.userList = this.userAll.inactive !== undefined ? this.userAll.inactive : []
        // console.log('data', this.userList)
        if (this.userList.length === 0) {
          this.disableTable = true
          this.showCountRequest = 0
        } else {
          this.disableTable = false
        }
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
    // filteredList () {
    //   return this.listUserForSelect.filter(listUser => {
    //     return listUser.name.toLowerCase().includes(this.searchUser.toLowerCase()) || listUser.email.toLowerCase().includes(this.searchUser.toLowerCase()) || listUser.phone.toLowerCase().includes(this.searchUser.toLowerCase())
    //   })
    // }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        var userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = userDetailSelling.seller_shop_id
        this.position = userDetailSelling.position
      }
      this.getData()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    getErrorMsg (msg) {
      // update_status_employee
      if (msg === 'This user is unauthorized.') {
        return ['กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดตรวจสอบและลองอีกครั้ง', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดตรวจสอบและลองอีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'EmployeeID not found.') {
        return ['ไม่พบรหัสพนักงาน', 'warning']
      } else if (msg === 'Unable to edit in your position.') {
        return ['ไม่สามารถแก้ไขตำแหน่งของตัวเองได้', 'warning']
      } else if (msg === 'Found customer of employee is active. Please check and try again.') {
        return ['พบลูกค้าของพนักงานที่ยังใช้งานอยู่ โปรดตรวจสอบและลองใหม่อีกครั้ง', 'warning']
        // edit_employee
      } else if (msg === 'Employee code is already exits.') {
        return ['รหัสพนักงานนี้ถูกใช้งานอยู่', 'warning']
      } else if (msg === 'Employee code is already exists.') {
        return ['รหัสพนักงานนี้ถูกใช้งานอยู่', 'warning']
      } else if (msg === 'emp_code must be greater than 5 characters and a maximum of 8 characters.') {
        return ['รหัสพนักต้องมีจำนวนมากกว่า 5 ตัวอักษร และ ไม่เกิน 8 ตัวอักษร', 'warning']
        // create_employee
      } else if (msg === 'Employee is already exists.') {
        return ['มีพนักงานคนนี้อยู่แล้ว', 'warning']
      } else if (msg === 'Employee not found.') {
        return ['ไม่พบพนักงาน', 'warning']
      } else if (msg === '') {
        return ['ระบบขัดข้อง กรุณาติดต่อเจ้าหน้าที่', 'warning']
      } else if (msg === 'An error has occurred. Please try again in an hour or two.') {
        return ['กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง', 'error']
      } else {
        return [msg, 'error']
      }
    },
    getRequest (item) {
      this.StateStatus = item
      // i dnk
      this.page = 1
    },
    countRequest (pagination) {
      this.showCountRequest = pagination.itemsLength
    },
    async getData () {
      this.$store.commit('openLoader')
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczListEmployee', data)
      var res = await this.$store.state.ModuleGraczEmployee.stateGraczListEmployee
      if (res.result === 'SUCCESS') {
        var listCatagory = res.data
        // assign for new data
        this.userAll.all = listCatagory.all_employee
        this.userAll.active = listCatagory.active_employee
        this.userAll.inactive = listCatagory.inactive_employee

        this.countAll = this.userAll.all.length
        this.countActive = this.userAll.active.length
        this.countInactive = this.userAll.inactive.length

        // set data to show
        if (this.StateStatus === 0) {
          this.userList = this.userAll.all
          if (this.userList.length === 0) {
            this.showCountRequest = this.userList.length
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        } else if (this.StateStatus === 1) {
          this.userList = this.userAll.active
          if (this.userList.length === 0) {
            this.showCountRequest = this.userList.length
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        } else if (this.StateStatus === 2) {
          this.userList = this.userAll.inactive
          if (this.userList.length === 0) {
            this.showCountRequest = this.userList.length
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        }
        this.$store.commit('closeLoader')
      } else {
        this.$store.commit('closeLoader')
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          this.disableTable = false
          var [msg, iconMsg] = this.getErrorMsg(res.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },

    // dialog Detail Edit Add
    async detailUser (empID) {
      var data = {
        seller_shop_id: this.seller_shop_id,
        emp_id: empID
      }
      await this.$store.dispatch('actionsGraczDetailEmployee', data)
      var res = await this.$store.state.ModuleGraczEmployee.stateGraczDetailEmployee
      if (res.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      this.selectedUserDetail = res.data
      this.selectFirstName = this.selectedUserDetail.first_name
      this.selectLastName = this.selectedUserDetail.last_name
      this.selectPosition = this.selectedUserDetail.position
      this.empNo = this.selectedUserDetail.emp_code
      // this.SelectUserToAdd(element)
      this.status = 'edit'
      this.dialogAddEdit = true
      console.log('selectedUserDetail', this.selectedUserDetail)
      // console.log('data to API detail', data)
    },
    async getUserForSelect () {
      this.listUserForSelect = []
      if (this.searchUser !== '') {
        var data = {
          seller_shop_id: this.seller_shop_id,
          username: this.searchUser
        }
        await this.$store.dispatch('actionsGraczSearchEmployee', data)
        var res = await this.$store.state.ModuleGraczEmployee.stateGraczSearchEmployee
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          console.log(res)
          if (res.result === 'SUCCESS') {
            this.listUserForSelect = res.data
            this.showUser = true
          } else {
            var msg = res.message
            this.showUser = false
            if (res.result === 'FAILED') {
              if (res.message === 'Employee not found.') {
                this.showStatus = 'ไม่พบข้อมูล'
                msg = 'ไม่พบพนักงาน'
              } else if (res.message === 'Employee is already exists.') {
                this.showStatus = 'มีพนักงานคนนี้อยู่แล้ว'
                msg = 'มีพนักงานคนนี้อยู่แล้ว'
              } else if (res.message === 'Parameter Missing. Please check and try again.') {
                this.showStatus = 'ไม่พบข้อมูล'
                msg = 'กรอกข้อมูลถูกต้อง'
              }
              this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
            } else {
              msg = res.result
              this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
            }
          }
        }
      }
    },
    edit () {
      this.clickSelectUser = true
    },
    SelectUserToAdd () {
      // assign value
      // this.selectedUserDetail = []
      this.selectFirstName = ''
      this.selectLastName = ''
      this.selectPosition = ''
      this.empNo = ''
      this.selectedUserDetail = this.listUserForSelect[0]
      this.clickSelectUser = true
    },
    switchStatus (status) {
      this.status = status
      this.dialogAddEdit = false
      this.dialogConfirmInactive = true
      console.log('this.status', this.status)
    },
    async save () {
      console.log(this.status)
      if (this.$refs.form.validate(true)) {
        var res = []
        if (this.status === 'edit') {
          var data1 = {
            seller_shop_id: this.seller_shop_id,
            emp_id: this.selectedUserDetail.emp_id,
            first_name: this.selectFirstName,
            last_name: this.selectLastName,
            emp_code: this.empNo,
            position: this.selectPosition
          }
          await this.$store.dispatch('actionsGraczEditEmployee', data1)
          res = await this.$store.state.ModuleGraczEmployee.stateGraczEditEmployee
          if (res.message === 'Not access this function.') {
            await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          }
          // res = { result: 'SUCCESS' }
        } else {
          var data = {
            seller_shop_id: this.seller_shop_id,
            emp_user_id: this.selectedUserDetail.emp_user_id,
            first_name: this.selectFirstName,
            last_name: this.selectLastName,
            position: this.selectPosition,
            emp_code: this.empNo
          }
          await this.$store.dispatch('actionsGraczCreateEmployee', data)
          res = await this.$store.state.ModuleGraczEmployee.stateGraczCreateEmployee
          if (res.message === 'Not access this function.') {
            await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          }
        }
        if (res.result === 'SUCCESS') {
          this.dialogAddEdit = false
          this.dialogSuccess = true
          setTimeout(() => { this.dialogSuccess = false }, 1500)
        } else {
          if (res.result === 'FAILED') {
            var [msg, iconMsg] = this.getErrorMsg(res.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          } else if (res.result === 'SERVER ERROR') {
            msg = 'ระบบขัดข้อง กรุณาลองใหม่ในภายหลัง'
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          }
        }
      } else {
        this.$nextTick(() => {
          const el = document.getElementsByClassName('error--text')
          if (el) {
            document
              .getElementsByClassName('error--text')[0]
              .scrollIntoView({ behavior: 'smooth', block: 'end' })
          }
        })
      }
      console.log('datas to API create', data)
      console.log('datas to API edit', data1)
      console.log('data send to API', res)
    },
    async switchStatusUser () {
      var data = {
        seller_shop_id: this.seller_shop_id,
        emp_id: this.selectedUserDetail.emp_id,
        emp_status: this.status
      }
      await this.$store.dispatch('actionsGraczUpdateStatusEmployee', data)
      var res = await this.$store.state.ModuleGraczEmployee.stateGraczUpdateStatusEmployee
      if (res.result === 'SUCCESS') {
        this.dialogConfirmInactive = false
        this.dialogSuccess = true
        setTimeout(() => { this.dialogSuccess = false }, 1500)
        this.resetDataAddEdit('')
      } else {
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          this.dialogConfirmInactive = false
          if (res.result === 'FAILED') {
            var [msg, iconMsg] = this.getErrorMsg(res.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          } else if (res.result === 'SERVER ERROR') {
            msg = 'ระบบขัดข้อง กรุณาลองใหม่ในภายหลัง'
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          }
        }
      }
      console.log('datas to API status', data)
      console.log('data send to API', res)
    },
    resetDataAddEdit (dialog) {
      console.log('function resetDataAddEdit')
      this.showUser = true
      this.status = ''
      this.selectFirstName = ''
      this.selectLastName = ''
      this.selectPosition = ''
      this.empNo = ''
      this.selectedUserDetail = []

      this.listUserForSelect = []
      this.searchUser = ''
      this.clickSelectUser = false
      this.selectPosition = ''
      this.empNo = ''
      if (dialog === 'dialogAddEdit') {
        this.dialogAddEdit = false
      } else if (dialog === 'dialogConfirmInactive') {
        this.dialogConfirmInactive = false
      } else if (dialog === 'dialogSuccess') {
        this.dialogSuccess = false
      }
      this.getData()
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    }
  }
}
</script>
<style scoped>
</style>
<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(7) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
          // outline: 2px solid rgba(28, 6, 6, 0.072);
        }
      }
    }
    thead {
      tr {
        th:nth-child(7) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 11;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
</style>
